"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Icon_1 = require("../icon/Icon");
require("./Toast.css");
var react_transition_group_1 = require("react-transition-group");
var Button_1 = require("../button/Button");
var UIProps_1 = require("../UIProps");
var classnames_1 = __importDefault(require("classnames"));
var ToastType;
(function (ToastType) {
    ToastType["success"] = "success";
    ToastType["info"] = "info";
    ToastType["warning"] = "warning";
    ToastType["error"] = "error";
})(ToastType = exports.ToastType || (exports.ToastType = {}));
var ToastComp = function (_a) {
    var _b = _a.timeout, timeout = _b === void 0 ? 0 : _b, _c = _a.type, type = _c === void 0 ? ToastType.info : _c, props = __rest(_a, ["timeout", "type"]);
    var timer = react_1.useRef();
    var onCloseRef = react_1.useRef(); //create ref to provide accurate value inside timeout closure
    onCloseRef.current = props.onClose;
    react_1.useEffect(function () {
        if (props.show && timeout > 0) {
            timer.current = setTimeout(function () {
                if (onCloseRef.current)
                    onCloseRef.current();
            }, timeout);
        }
        else {
            window.clearTimeout(timer.current);
        }
    }, [props.show]);
    react_1.useEffect(function () {
        return function () {
            window.clearTimeout(timer.current);
        };
    }, []);
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: props.show, timeout: { appear: 500, enter: 500, exit: 500 }, classNames: "Toast", appear: true, unmountOnExit: true, onEnter: function () {
            document.documentElement.scrollTop = 0;
        }, onEntered: function () {
            if (props.onEntered) {
                props.onEntered();
            }
        }, onExited: props.onExited },
        react_1.default.createElement("div", __assign({ role: 'alert' }, UIProps_1.setUIProps(props), { className: classnames_1.default("Toast Toast-" + props.type, props.className, {
                'Toast-overlay': props.overlay,
                'Toast-banner': !props.overlay,
                'Toast-hasClose': props.hasCloseButton,
            }) }),
            props.iconType && (react_1.default.createElement(Icon_1.Icon, { className: "Toast_icon", type: props.iconType, "aria-hidden": true })),
            props.message && react_1.default.createElement("p", { className: "Toast_message" }, props.message),
            props.children,
            props.hasCloseButton && (react_1.default.createElement(Button_1.Button, { className: "Toast_close", "aria-label": 'Alert Close', onClick: function (e) {
                    if (timeout)
                        window.clearTimeout(timer.current);
                    if (props.onClose)
                        props.onClose(e);
                } },
                react_1.default.createElement(Icon_1.Icon, { type: Icon_1.IconType.close, varient: Icon_1.IconVarient.outline, "aria-hidden": true }))))));
};
exports.Toast = react_1.default.memo(ToastComp);
